import { Component, Input } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { SelectOption, TemplateSelectComponent } from "../../templates/template-select/template-select.component";

@Component({
  selector: "app-prefix-idf[options]",
  imports: [TemplateSelectComponent],
  templateUrl: "./prefix-idf.component.html",
  styleUrl: "./prefix-idf.component.less",
})
export class PrefixIdfComponent extends PrefixComponent<string> {
  @Input()
  public options: SelectOption[];

  public multiple: boolean;

  public constructor() {
    super();
    this.options = [];
    this.multiple = false;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["idf"];
  }
}
